/* eslint quote-props: 0 */
export default {
  // Error Messages
  // Error 401
  '4011': 'invalid email or password',
  // Error 403
  '4031': 'inactive 30 minutes',
  '4032': 'expired token',
  '4033': 'session was overridden',
  '4034': 'already logged out',
  '4035': 'account inactive contact admin',
  '4036': 'invalid token',
  '4037': 'Password expired',
  '4038': 'same password is not allowed',
};




// WEBPACK FOOTER //
// ./src/i18n/en.js